import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useSelector, useDispatch } from 'react-redux';

import SelectImageActionModalContainer from './SelectImageActionModalContainer';
import {setProductSelectImageModal} from '../../../../store/slice/PharmaSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  width: { lg: '85%', xs: '95%' },
  height: { lg: '85%', xs: '95%' },
  borderRadius: 3,
  //overflow:'scroll',
  p: 1,
  backgroundColor:'secondary.lighter',
};

export default function SelectImageActionModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);;
  const {selectImageModalOpen, productObj} = useSelector((state)=>state.pharmaslice.productDashboard);

  useEffect(()=>{
  },[selectImageModalOpen])

  const handleModalClose=()=>{
    handleClose();
    dispatch(setProductSelectImageModal(false));
  }
  return (
    <Modal
       open={selectImageModalOpen===undefined?false:selectImageModalOpen}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} >

        <Grid container direction="row" justifyContent="space-between" alignItems="center"
        sx={{borderBottom:'1px solid #e0e0e0'}}>
          <Grid item>
            <Typography variant="h5"  >
              Select Image @ {productObj.title}
            </Typography>
          </Grid>
          <Grid item>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleModalClose()} />
          </Grid>
        </Grid>
        <Grid item paddingTop={1}> 
            < SelectImageActionModalContainer/>
        </Grid>

      </Box>
    </Modal>
  );
}